// Profilbild-Kreis für Chat-Listen und -Verlauf — reiner Anzeige-Baustein ohne Kontext-Zugriff.
import { useState } from 'react';
import { initialen } from '../../../../lib/chat/nachrichten';
import { avatarVerlauf } from '../../../../lib/island/chatDarstellung';

/** Profilbild aus profiles.avatar_url (öffentlicher avatars-Bucket); ohne Bild Initialen auf
 *  einem festen Farbverlauf je Name (iMessage-Stil). */
export function Avatar({ name, bild, groesse = 32 }: { name: string; bild?: string | null; groesse?: number }) {
  const [kaputt, setKaputt] = useState(false);
  const url = (bild || '').trim();
  if (url && !kaputt) {
    return (
      <img
        src={url}
        alt={name}
        onError={() => setKaputt(true)}
        className="shrink-0 rounded-full object-cover"
        style={{ width: groesse, height: groesse }}
      />
    );
  }
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-full"
      style={{ width: groesse, height: groesse, background: avatarVerlauf(name), color: '#fff', fontWeight: 800, fontSize: Math.round(groesse * 0.36) }}
      aria-hidden
    >
      {initialen(name)}
    </span>
  );
}
